import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { DatePicker } from "antd";
import { useEffect, useMemo, useState } from "react";
import { getWidthFromHeader, renderValueAsJSX } from "../../../../until";
import { Dashboard } from "../../../../components/ExportImgFigma";
import "../../styles.scss";
import { ListField } from "../../../../api/Customer_V2/customerApi_V2";
import { ICustomerFields } from "../../../../api/salesSericeCustomer/salesSericeCustomerApi";
import { ColumnKey } from "../../../Customers/Tabs/CarListCardClone";
import { FlattenedField } from "../../../CustomersV2/indexV2";
import FilterHeader from "./Components/FilterHeader";
import { mixDate } from '../../../../services/mixin'

const { RangePicker } = DatePicker;

const dataListFieldsByCustomerRecordActive = [
  {
    id: 99,
    title: "Lịch sử tiếp xúc",
    fields: [
      { id: 1, fieldCode: "unit", fieldLabel: "Đơn vị", inputType: "text", isActive: 1 },
      { id: 2, fieldCode: "pointOfSale", fieldLabel: "Điểm bán hàng", inputType: "text", isActive: 1 },
      { id: 3, fieldCode: "invoiceNumber", fieldLabel: "Số hóa đơn", inputType: "text", isActive: 1 },
      { id: 4, fieldCode: "repairOrderNumber", fieldLabel: "Số LSC", inputType: "text", isActive: 1 },
      { id: 5, fieldCode: "repairDate", fieldLabel: "Ngày sửa chữa", inputType: "text", isActive: 1 },
      { id: 6, fieldCode: "repairType", fieldLabel: "Loại hình sửa chữa", inputType: "text", isActive: 1 },
      { id: 7, fieldCode: "contactPerson", fieldLabel: "Người liên hệ", inputType: "text", isActive: 1 }
    ]
  }
];

const dataListFieldsByCustomerRecordNotActive = [
  { id: 99, title: "Lịch sử tiếp xúc", fields: [] }

];

const daumData = [
  {
    id: 1,
    code: "C53343401K1234",
    name: "Xe Đức - Du lịch",
    groupPermissionId: 100,
    fields: [
      { fieldId: 1, fieldCode: "unit", value: "Du lịch" },
      { fieldId: 2, fieldCode: "pointOfSale", value: "53343401K1234" },
      { fieldId: 3, fieldCode: "invoiceNumber", value: "Trắng" },
      { fieldId: 4, fieldCode: "repairOrderNumber", value: "408 20G AT" },
      { fieldId: 5, fieldCode: "repairDate", value: "21/02/2022" },
      { fieldId: 6, fieldCode: "repairType", value: "075/2025/HĐMB/KIAVL-KH" },
      { fieldId: 7, fieldCode: "contactPerson", value: "00001226" }
    ],
    permissionMenu: { groupPermissionId: 100, view: true, edit: false, delete: false }
  }
];

interface Prop {
  isSettingShow?: boolean;
  activeServiceRecordsTab: string
  setSettingShow?: (isClose: boolean) => void;
}

const ContactHistory = ({ stData = {} as any }) => {

  const [dataFilterActive, setDataFilterActive] = useState<FlattenedField[]>([]);
  const [dataFilterNoActive, setDataFilterNoActive] = useState<ListField[]>([]);
  const [columnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 15, total: 0 });

  useEffect(() => {
    gListFieldsActive();
  }, []);

  useEffect(() => {
    const codes = dataFilterActive.map((f) => f.fieldCode);
    setColumnsMapShow(codes);
  }, [dataFilterActive]);


  const gListFieldsActive = async () => {
    const flattenedFields = dataListFieldsByCustomerRecordActive.flatMap((choice) =>
      choice.fields.map((field) => ({ ...field, parentId: choice.id }))
    );
    setDataFilterActive(flattenedFields);
    gListFieldsNotActive();
  };

  const gListFieldsNotActive = async () => {
    setDataFilterNoActive(dataListFieldsByCustomerRecordNotActive);
  };

  const generateColumnsFromCodesAgGridReact = (
    codes: ColumnKey[],
    fields: ICustomerFields[],
    actionColumn?: ColDef<any, any>,
    onToggleStatus?: (id: number, next: boolean, rowData: any) => void
  ): ColDef[] => {
    const baseColumns = codes
      ?.map((code) => {
        const field = fields.find((f) => f.fieldCode === code);
        if (!field) return null;

        return {
          headerName: field.fieldLabel,
          headerComponent: FilterHeader,
          field: field.fieldCode,
          colId: field.fieldCode,
          sortable: true,
          width: getWidthFromHeader(field.fieldLabel),
          cellRenderer: (params: any) => renderValueAsJSX(params.value,field.fieldCode)
        } as ColDef;
      })
      .filter(Boolean) as ColDef[];

    return actionColumn ? [actionColumn, ...baseColumns] : baseColumns;
  };

  const memoizedColumnDefs = useMemo(() => {
    return generateColumnsFromCodesAgGridReact(
      columnsMapShow,
      dataFilterActive,
      undefined,
      (id: number, next: boolean, rowData: any) => console.log(id, next, rowData)
    );
  }, [columnsMapShow, dataFilterActive]);

  const tableData = useMemo(() => {
    return daumData.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field) => {
        acc[field.fieldCode] = field.value;
        return acc;
      }, {});

      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues
      };
    });
  }, []);

  const newData = () => {
    return stData.xesohuu_show && stData.xesohuu_show.vehicle_repair_appointments ? stData.xesohuu_show.vehicle_repair_appointments : []
  }
  return (
    <>
      <div className="custom-page-css w-full flex gap-3 mb-3">
        <div className="custom-page-css  flex flex-1 flex-column rounded border mw-33">
          <div className="custom-page-css w-full flex items-center gap-4 p-3 border-b">
            <div className="custom-page-css flex items-center justify-center p-1 bg-E6F7FF rounded-full w-1/3">
              <img
                src={Dashboard}
                alt=""
                style={{ height: 16, width: 16, objectFit: "contain" }}
              />
            </div>
            <span className="custom-page-css text-xl font-light text-475467">
              Tổng quan
            </span>
          </div>
          <div className="custom-page-css flex py-2">
            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 border-r">
              <span className="custom-page-css text-2xl font-light font-medium px-1 text-344054">
                {newData().length}
              </span>
              <span className="custom-page-css text-xl font-light text-475467">
                Số lần tiếp xúc
              </span>
            </div>
            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 ">
              <span className="custom-page-css text-2xl font-light font-medium px-1 text-344054">
                {newData().length > 0 ? mixDate(newData()[0]?.tentative_registration_date) : ""}
              </span>
              <span className="custom-page-css text-xl font-light text-475467">
                Ngày tiếp xúc gần nhất
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="ag-theme-alpine custom-table-ag custom-page-css" style={{ width: "100%" }}>
        <AgGridReact
          rowData={newData()}
          columnDefs={[
            { field: "tentative_branch_name", headerName: "Đơn vị" },
            { field: "tentative_cabin_no", headerName: "Khoang sửa chữa" },
            { field: "tentative_contact", headerName: "Người liên hệ mang xe đi sửa chữa" },
            { field: "tentative_customer_request", headerName: "Yêu cầu KH" },
            { field: "tentative_effective_get_date", headerName: "Ngày bắt đầu sửa chữa" },
            { field: "tentative_email", headerName: "Email Người liên hệ mang xe đi sửa chữa" },
            { field: "tentative_get_in_time", headerName: "Khung giờ hẹn" },
            { field: "tentative_is_arrive", headerName: "Đúng/sai hẹn - Đến không?" },
            { field: "tentative_mobile_contact", headerName: "SĐT Người liên hệ mang xe đi sửa chữa" },
            { field: "tentative_profit_center_name", headerName: "Loại hình dịch vụ" },
            { field: "tentative_registration_date", headerName: "Ngày hẹn" },
            { field: "tentative_route_name", headerName: "Chi nhánh" },
          ]}
          rowHeight={55}
          domLayout="autoHeight"
          className="my-auto-height-grid w-100"
        />
      </div>
    </>
  );
};
export default ContactHistory;
